import { useState } from "react";
import { toast } from "sonner";
import { ArrowUpRight, Mail, Check } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Compact newsletter form used inside the footer.
 * On success, replaces itself with a friendly confirmation.
 */
export default function FooterNewsletter() {
    const [email, setEmail] = useState("");
    const [rgpd, setRgpd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) return toast.error("Introduza um email válido");
        if (!rgpd) return toast.error("Aceite a política de privacidade");
        setLoading(true);
        try {
            const { data } = await api.post("/newsletter/subscribe", { email, source: "footer", rgpd_consent: true });
            if (data.already) toast.info("Já se encontra subscrito. Obrigado!");
            else toast.success("Subscrição feita — verifique o seu email.");
            setDone(true);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro ao subscrever. Tente novamente.");
        } finally { setLoading(false); }
    };

    if (done) {
        return (
            <div className="flex items-center gap-2 text-sm text-white/85 bg-white/5 border border-white/15 rounded-full px-4 py-3" data-testid="footer-newsletter-done">
                <span className="w-6 h-6 rounded-full bg-[hsl(var(--copper))] flex items-center justify-center">
                    <Check className="w-3.5 h-3.5" />
                </span>
                Obrigado — verifique o seu email.
            </div>
        );
    }

    return (
        <form onSubmit={submit} className="space-y-2" data-testid="footer-newsletter-form">
            <div className="relative">
                <Mail className="w-4 h-4 text-white/60 absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none z-10" />
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="o.seu.email@exemplo.pt"
                    className="footer-newsletter-input w-full bg-white/10 border border-white/25 rounded-full pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-[hsl(var(--copper))]"
                    data-testid="footer-newsletter-email"
                    autoComplete="email"
                    style={{ colorScheme: "dark" }}
                />
            </div>
            <label className="flex items-start gap-2 text-[11px] text-white/60 leading-snug">
                <input type="checkbox" checked={rgpd} onChange={(e) => setRgpd(e.target.checked)} className="mt-0.5 accent-[hsl(var(--copper))]" data-testid="footer-newsletter-rgpd" />
                <span>Aceito receber a newsletter e a política de privacidade.</span>
            </label>
            <button
                type="submit"
                disabled={loading}
                className="w-full bg-[hsl(var(--copper))] hover:bg-[hsl(var(--copper-hover))] text-white rounded-full px-4 py-2.5 text-sm font-medium inline-flex items-center justify-center gap-2 transition disabled:opacity-50"
                data-testid="footer-newsletter-submit"
            >
                {loading ? "A enviar…" : "Subscrever"}
                <ArrowUpRight className="w-4 h-4" />
            </button>
        </form>
    );
}
